import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Bell, Crosshair } from "lucide-react";
import { LanguageMenu } from "@/components/LanguageMenu";
import { Logo } from "@/components/Logo";
import { useLocation } from "@/context/LocationContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function Header() {
  const nav = useNavigate();
  const { loc, requestGPS } = useLocation();
  const { user, setAuthOpen, badges } = useAuth();
  const unread = badges?.notifications || 0;

  const gps = async () => {
    try { await requestGPS(); toast.success("Lokacioni u aktivizua"); }
    catch { toast.error("Lejo lokacionin në shfletues për ta aktivizuar GPS-in"); }
  };

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-100 px-4 py-2.5 flex items-center justify-between gap-2">
      <Logo />
      <div className="flex items-center gap-1.5">
        <button
          data-testid="location-selector"
          onClick={gps}
          className="flex items-center gap-1 max-w-[150px] bg-slate-100 hover:bg-slate-200 transition-colors rounded-full pl-2 pr-2.5 py-1.5 text-xs font-semibold text-slate-700"
        >
          {loc.city ? <MapPin className="w-3.5 h-3.5 text-emerald-500 shrink-0" /> : <Crosshair className="w-3.5 h-3.5 text-emerald-500 shrink-0" />}
          <span className="truncate">{loc.city || "Aktivizo GPS"}</span>
        </button>
        <LanguageMenu />
        <button
          data-testid="notifications-button"
          onClick={() => (user && user !== false ? nav("/njoftimet") : setAuthOpen(true))}
          className="relative p-2 rounded-full hover:bg-slate-100 transition-colors"
        >
          <Bell className="w-5 h-5 text-slate-700" />
          {unread > 0 && (
            <span className="absolute top-0.5 right-0.5 min-w-[16px] h-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-pulse">{unread}</span>
          )}
        </button>
        <button
          data-testid="header-profile-button"
          onClick={() => (user && user !== false ? nav("/profil") : setAuthOpen(true))}
          className="w-9 h-9 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 text-white flex items-center justify-center font-bold text-sm shadow-sm overflow-hidden"
        >
          {user && user !== false
            ? (user.avatar ? <img src={user.avatar} alt="" className="w-full h-full object-cover" /> : user.name?.[0]?.toUpperCase())
            : <span className="text-xs" data-no-translate>Hyr</span>}
        </button>
      </div>
    </header>
  );
}

export default Header;
